import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DetailResult from "../../subtabs/WMTransactionDetailSubTab";
import WMAptmmtsTab from "../../subtabs/WMAptmmtsTab";
import TransactionStagingAssignTab from "../../subtabs/TransactionStagingAssignTab";
import TransactionTransportTab from "../../subtabs/TransactionTransportTab";
import WMSerialNumberNoHeaderInfoTab from "../../subtabs/WMSerialNumberNoHeaderInfoTab";
import ChargesDetailTab from "../../subtabs/ChargesDetailTab";
import HistoryTransaction from "../../subtabs/HistoryTransaction";
import CustomerSubTab from "../../subtabs/CustomerSubTab";
import ItemSubTab from "../../subtabs/ItemSubTab";
import LocationSubTab from "../../subtabs/LocationSubTab";
import AllTransactionsSubTab from "../../subtabs/AllTransactionsSubTab";
import CaretsDetailSubTab from "../../subtabs/CaretsDetailSubTab";
import LaborTrackingSubTab from "../../subtabs/LaborTrackingSubTab";
import TransactionDetailsByLotSubTab from "../../subtabs/TransactionDetailsByLotSubTab";
import ChargesDetailByItemSubTab from "../../subtabs/ChargesDetailByItemSubTab";
import LotByItemSubTab from "../../subtabs/LotByItemSubTab";
import ItemSerialNumbersSubTab from "../../subtabs/ItemSerialNumbersSubTab";
import {
    GetCustomerGridGridData
} from "../../../../../../om/services/SalesOrderService";

const SubLotSubTabs = forwardRef((props, ref) => {
    const orderDetailTab = 1;
    const chargesByItem = 2;
    const lotTab = 3;
    const itemserialnumberTab = 4;
    const serialNumberTab = 5;
    const chargesTab = 6;
    const histTransTab = 7;
    const custTransTab = 8;
    const itemTab = 9;
    const locationTab = 10;
    const allTransTab = 11;
    const openTransTab = 12;
    const crateDetailTab = 13;
    const getcrateDetailUrl = "wm/TransactionManagement/GetCrateDetails";
    const laborTrackingTab = 14;
    const getchargesByItemUrl = "wm/TransactionManagement/GetChargesByItem";
    const GetLotsByItemUrl = "wm/TransactionManagement/GetLotsByItem";
    const GetItemSerialNumbersUrl = "wm/TransactionManagement/GetItemSerialNumbers";
    const getGetTransactionDetailByItemUrl = "wm/TransactionManagement/GetTransactionDetailBySubLot";
    const getLaborTrackingDetailUrl = "wm/TransactionManagement/GetLaborTrackingDetails";
    const getcaretDetailUrl = "wm/TransactionManagement/GetCrateDetails";
    const getOrderDetailSearchUrl = "wm/TransactionManagement/GetTransactionDetail";
    const getAptmmtsUrl = "wm/TransactionManagement/GetTransactionAptmmtsDetail";
    const GetstagingAssignUrl = "wm/TransactionManagement/GetTransactionStagingAssignDetail";;
    const transportUrl = "wm/TransactionManagement/GetTransactionTransportDetail";
    const serialNumberUrl = "wm/TransactionManagement/GetTransactionSerialNumberNoDetail";
    const chargesUrl = "wm/TransactionManagement/GetChargesDetail";
    const [orderDetailDataSource, setOrderDetailDataSource] = useState(null);
    const [aptmmtsDataSource, setAptmmtsDataSource] = useState(null);
    const [stagingAssignDataSource, setStagingAssignDataSource] = useState(null);
    const [transportDataSource, setTransportDataSource] = useState(null);
    const [serialNumbertDataSource, setserialNumbertDataSource] = useState(null);
    const [chargesDataSource, setchargesDataSource] = useState(null);
    const [crateDetailDataSource, setCrateDetailDataSource] = useState(null);
    const [selectedRow, setSelectedRow] = useState([]);
    const [activeTab, setActiveTab] = useState(orderDetailTab);
    const [arOpenItemsDataSource, setArOpenItemsDataSource] = useState(null);
    const [dataSource, setDataSource] = useState(null);
    const getDataUrl = "wm/TransactionManagement/GetTransactionHeader";
    const transactionTypeAll = 'A';
    const commited = 1;
    const all=2;
    const open=0;
    const GetCrateDetailsGridData = (accessToken, url, headerId) => {
        const resultData = createStore({
            key: 'rowid',
            loadParams:
            {
                headerId: function () {
                    return headerId;
                },
            },
            loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });
        return resultData;
    };
    const GetLotsByItem = (accessToken, url, itemid) => {
        const resultData = createStore({
            key: 'rowId',
            loadParams:
            {
                itemid: function () {
                    return itemid;
                },
            },
            loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });
        return resultData;
    };
    const GetTransDetailGridData = (accessToken, url, sublotid) => {
        const resultData = createStore({
            key: 'rowid',
            loadParams:
            {
                sublotid: function () {
                    return sublotid;
                },
            },
            loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });
        return resultData;
    };
    const initialItemFormFields = {
        R_CUSTOMER: '',
        itemCode: '',
        itemDescription1: '',
        customerName: '',
    };
    const [ItemformFields, setItemformFields] = useState(initialItemFormFields);
    const GetLocationsUrl = "wm/TransactionManagement/GetLocationsByCustomer";
    const initialLocationFormFields = {
        Warehouse: '',
        Location: '',
        Description: '',
        Classcode: '',
    };
    const [LocationformFields, setLocationformFields] = useState(initialLocationFormFields);
    const GetItemGridData = (accessToken, url, formFields, customerId) => {
        const resultData = createStore({
            key: 'rowId',
            loadParams:
            {
                Transactiontype: function () {
                    return 'Z';
                },
            },
            loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });
        return resultData;
    };
    const GetGridData = (accessToken, url, formFields, type, status) => {
        const resultData = createStore({
            key: 'rowid',
            loadParams:
            {
                Recordtype: function () {
                    return 'R';
                },
                Transactiontype: function () {
                    return type;
                }, transStatus: function () {
                    return status;
                },
            },
            loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });
        return resultData;
    };
    const searchData = (type, status) => {
        var resultData = GetGridData(props.accessToken, getDataUrl, null, type, status);
        setDataSource(resultData);
    };
    const getCustomerListUrl = "om/SaleOrder/GetCustomerList";
    const GetAllItemsDataUrl = "wm/TransactionManagement/GetItemsByCustomer";
    const initialFormFields = {
        R_CUSTOMER: '',
        Name: '',
        Address1: '',
        Address2: '',
        City: '',
        State: '',
        Zip: '',
        Tel: '',

    };
    const [formFields, setformFields] = useState(initialFormFields);
    const searchcustData = (formFields) => {
        var resultData = GetCustomerGridGridData(props.accessToken, getCustomerListUrl, formFields);
        setDataSource(resultData);
    };
    const searchItemData = (formfeilds, url, customerId) => {
        var resultData = GetItemGridData(props.accessToken, url, formfeilds, customerId);
        setDataSource(resultData);
    };

    const GetOrderDetailGridData = (accessToken, url, headerId) => {
        const resultData = createStore({
            key: 'rowid',
            loadParams:
            {
                headerId: function () {
                    return headerId;
                },
            },
            loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });
        return resultData;
    };
    useImperativeHandle(ref, () => ({
        updateData(data) {
            setSelectedRow(data);
        }
    }));

    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
    };
    const LoadTabsData = () => {

        if (selectedRow && selectedRow?.rowId && activeTab === orderDetailTab) {
            var resultData = GetTransDetailGridData(props.accessToken, getGetTransactionDetailByItemUrl, selectedRow.rowId);
            setArOpenItemsDataSource(resultData);
        }
        else if (selectedRow && selectedRow?.rowId && activeTab === chargesByItem) {
            var resultData = GetTransDetailGridData(props.accessToken, getchargesByItemUrl, selectedRow.rowId);
            setAptmmtsDataSource(resultData);
        }
        else if (selectedRow && selectedRow?.rowId && activeTab === lotTab) {
            var resultData = GetLotsByItem(props.accessToken, GetLotsByItemUrl, selectedRow.rowId);
            setAptmmtsDataSource(resultData);
        }
        else if (selectedRow && selectedRow?.rowId && activeTab === itemserialnumberTab) {
            var resultData = GetLotsByItem(props.accessToken, GetItemSerialNumbersUrl, selectedRow.rowId);
            setAptmmtsDataSource(resultData);
        }
        else if (selectedRow && selectedRow?.rowId && activeTab === chargesTab) {
            var resultData = GetOrderDetailGridData(props.accessToken, chargesUrl, selectedRow.rowId);
            setchargesDataSource(resultData);
        }
        else if (activeTab === histTransTab) {
            searchData(transactionTypeAll,commited);
        }
        else if (activeTab === custTransTab) {
            searchcustData(formFields);
        }
        else if (activeTab === itemTab) {
            searchItemData(ItemformFields, GetAllItemsDataUrl, selectedRow.rowId);
        }
        else if (activeTab === locationTab) {
            searchItemData(LocationformFields, GetLocationsUrl, selectedRow.rowId);
        }
        else if (activeTab === allTransTab) {
            searchData(transactionTypeAll,all);
        }
        else if (activeTab === openTransTab) {
            searchData(transactionTypeAll,open);
        }
        else if (selectedRow && selectedRow?.rowId && activeTab === crateDetailTab) {
            var resultData = GetCrateDetailsGridData(props.accessToken, getcrateDetailUrl, selectedRow.rowId);
            setCrateDetailDataSource(resultData);
        }


    }
    useEffect(() => {
        LoadTabsData();
    }, [selectedRow, activeTab]);
    return (
        <div>
            <div className="tab-bar">
                <div
                    className={`tab ${activeTab === orderDetailTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(orderDetailTab)}
                >
                    SubLot Trans
                </div>
                <div
                    className={`tab ${activeTab === histTransTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(histTransTab)}
                >
                    Hist/Trans
                </div>
                <div
                    className={`tab ${activeTab === custTransTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(custTransTab)}
                >
                    Customers
                </div>
                <div
                    className={`tab ${activeTab === itemTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(itemTab)}
                >
                    Items
                </div>
                <div
                    className={`tab ${activeTab === locationTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(locationTab)}
                >
                    Locations
                </div>
                <div className={`tab ${activeTab === allTransTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(allTransTab)}
                >
                    All-Trans
                </div>
               
                <div
                    className={`tab ${activeTab === openTransTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(openTransTab)}
                >
                    Open-Trans
                </div>
                <div
                    className={`tab ${activeTab === crateDetailTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(crateDetailTab)}
                >
                    Crates Details
                </div>

            </div >
            {activeTab === orderDetailTab && (
                <TransactionDetailsByLotSubTab data={arOpenItemsDataSource} />
            )}
            {
                activeTab === chargesByItem && (
                    <ChargesDetailByItemSubTab data={aptmmtsDataSource} />
                )
            }
            {
                activeTab === lotTab && (
                    <LotByItemSubTab data={aptmmtsDataSource} />
                )
            }
            {
                activeTab === itemserialnumberTab && (
                    <ItemSerialNumbersSubTab data={aptmmtsDataSource} />
                )
            }
            {
                activeTab === serialNumberTab && (
                    <WMSerialNumberNoHeaderInfoTab data={serialNumbertDataSource} />
                )
            }
            {
                activeTab === chargesTab && (
                    <ChargesDetailTab data={chargesDataSource} />
                )
            }
            {
                activeTab === histTransTab && (
                    <HistoryTransaction data={dataSource} />
                )
            }
            {
                activeTab === custTransTab && (
                    <CustomerSubTab data={dataSource} />
                )
            }
            {
                activeTab === itemTab && (
                    <ItemSubTab data={dataSource} />
                )
            }
            {
                activeTab === locationTab && (
                    <LocationSubTab data={dataSource} />
                )
            }
            {
                activeTab === allTransTab && (
                    <AllTransactionsSubTab data={dataSource} />
                )
            }
            {
                activeTab === openTransTab && (
                    <AllTransactionsSubTab data={dataSource} />
                )
            }
            {activeTab === crateDetailTab && (
                <CaretsDetailSubTab data={crateDetailDataSource} />
            )}
        </div >
    );
});

export default SubLotSubTabs;